const QuestionPreviewTypes = {
  assignmentPreview: 'assignmentPreview',
  editAssignmentPreview: 'editAssignmentPreview',
  classRoomPreview: 'classRoomPreview',
  questionPreview : 'questionPreview',
  assignmentReportPreview: 'assignmentReportPreview',
};
  
export default QuestionPreviewTypes;